import { UserAttemptType } from "../../enums";
import { MediaDto } from "../../interfaces/media";
import { baseApi } from "./baseApi";

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    toggleBlockUser: builder.mutation<any, { id: string; state: boolean }>({
      query: ({ id, state }) => ({
        url: `/api/user/toggle-block/${state}/${id}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: [
        "Paginated-Teacher-Admins",
        "Paginated-Head-Teacher-Admins",
        "Paginated-Admins",
        "Paginated-Students",
        "Paginated-Parents",
        "Paginated-Teachers",
      ],
    }),
    toggleVerifyUser: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/toggle-verification",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "Paginated-Teacher-Admins",
        "Paginated-Head-Teacher-Admins",
        "Paginated-Admins",
        "Paginated-Students",
        "Paginated-Parents",
        "Paginated-Teachers",
      ],
    }),
    deleteUser: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "Paginated-Teacher-Admins",
        "Paginated-Head-Teacher-Admins",
        "Paginated-Admins",
        "Paginated-Students",
        "Paginated-Parents",
        "Paginated-Teachers",
      ],
    }),
    undoDeleteUser: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/user/undo-delete/${id}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: [
        "Paginated-Teacher-Admins",
        "Paginated-Head-Teacher-Admins",
        "Paginated-Admins",
        "Paginated-Students",
        "Paginated-Parents",
        "Paginated-Teachers",
      ],
    }),
    resetUserAttempt: builder.mutation<
      any,
      { id: string; type: UserAttemptType }
    >({
      query: ({ id, type }) => ({
        url: `/api/user/reset/${type}/${id}`,
        method: "PATCH",
        body: null,
      }),
    }),
    uploadUserProfilePhoto: builder.mutation<
      MediaDto,
      {
        file: File;
        onProgress?: (progress: number) => void;
      }
    >({
      query: ({ file, onProgress }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: `/api/user/profile/photo/me`,
          method: "POST",
          data: formData,
          onUploadProgress: (event: any) => {
            if (event.total && onProgress) {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          },
        };
      },
      invalidatesTags: ["Account"],
    }),
  }),
});

export const {
  useToggleBlockUserMutation,
  useToggleVerifyUserMutation,
  useDeleteUserMutation,
  useUndoDeleteUserMutation,
  useResetUserAttemptMutation,
  useUploadUserProfilePhotoMutation,
} = userApi;
